import {
  ButtonBase,
  createStyles,
  Theme,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';


const styles = (theme: Theme) => createStyles({
  focusVisible: {},
  image: {
    '&:hover, &$focusVisible': {
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
      zIndex: 1,
    },
    height: 300,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      height: 150,
      width: '100% !important', // Overrides inline-style
    },
  },
  imageBackdrop: {
    backgroundColor: theme.palette.common.black,
    bottom: 0,
    left: 0,
    opacity: 0.4,
    position: 'absolute',
    right: 0,
    top: 0,
    transition: theme.transitions.create('opacity'),
  },
  imageButton: {
    alignItems: 'center',
    bottom: 0,
    color: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  imageMarked: {
    backgroundColor: theme.palette.common.white,
    bottom: -2,
    height: 3,
    left: 'calc(50% - 9px)',
    position: 'absolute',
    transition: theme.transitions.create('opacity'),
    width: 18,
  },
  imageSrc: {
    backgroundPosition: 'center 40%',
    backgroundSize: 'cover',
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  imageTitle: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 4}px ${theme.spacing.unit + 6}px`,
    position: 'relative',
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    width: '100%',
  },
});

declare type stylesKeys = 'focusVisible' | 'image' | 'imageBackdrop' | 'imageButton' | 'imageMarked' | 'imageSrc' | 'imageTitle' | 'root';

declare interface ImageButtonProps {
  icon?: any;
  onClick: () => void;
  url?: string;
  width?: string;
  title?: string;
}

class ImageButton extends React.Component<ImageButtonProps & WithStyles<stylesKeys>, {}> {

  public state = {
    anchorEl: null,
  };

  public render() {
    const { classes, icon, onClick, url, title } = this.props;
    const width = this.props.width || '100%';

    return (
      <div className={classes.root}>
        <ButtonBase
          focusRipple={true}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width,
          }}
          onClick={onClick}
        >
          <span
            className={classes.imageSrc}
            style={url
              ? {
                  backgroundImage: `url(${url})`,
                }
              : {}
            }
          />
          <span className={classes.imageBackdrop} />
          <span className={classes.imageButton}>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.imageTitle}
            >
              {icon}
              {title}
              <span className={classes.imageMarked} />
            </Typography>
          </span>
        </ButtonBase>
      </div>
    );
  }

}

export default withStyles<stylesKeys>(styles)(observer(ImageButton));


// WEBPACK FOOTER //
// ./src/components/imageButton/ImageButton.tsx